var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { flow, makeAutoObservable, runInAction } from "mobx";
import { getRandomNumericString } from "../../utils/string.utils";
import { isFunction } from "../../utils/typeChecks.utils";
import tick from "../../utils/wait.utils";
export var makeDefaultDialogActions = function () { return [
    {
        name: 'negative',
        label: 'Cancel',
        buttonClass: 'subtle',
        action: function () { return false; },
    },
    {
        name: 'positive',
        label: 'OK',
        action: function () { return true; },
    },
]; };
var Dialog = /** @class */ (function () {
    function Dialog(config, controller) {
        var _this = this;
        this.id = getRandomNumericString();
        this.status = 'beforeOpen';
        this.actions = [];
        var ref = this;
        this.config = config;
        if (!this.config.name)
            this.config.name = this.id;
        this.controller = controller;
        this.status = 'opened';
        this.promise = new Promise(function (resolve, reject) {
            var defaultActions = makeDefaultDialogActions();
            var shouldAddDefaultActions = _this.config.defaultActions ? _this.config.defaultActions
                .map(function (name) { return defaultActions.find(function (i) { return i.name === name; }); })
                .filter(function (i) { return !!i; }) : (_this.config.actions ? [] : defaultActions);
            var providedActions = __spreadArray(__spreadArray([], shouldAddDefaultActions, true), (_this.config.actions || []), true);
            providedActions.forEach(function (a) {
                a.id = getRandomNumericString();
                a.waiting = false;
                var action = a.action;
                a.action = flow(function () {
                    var result, _a, e_1;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _b.trys.push([0, 4, 5, 6]);
                                result = void 0;
                                a.waiting = true;
                                if (!isFunction(action)) return [3 /*break*/, 2];
                                return [4 /*yield*/, action()];
                            case 1:
                                _a = _b.sent();
                                return [3 /*break*/, 3];
                            case 2:
                                _a = void 0;
                                _b.label = 3;
                            case 3:
                                result = _a;
                                resolve(result);
                                return [3 /*break*/, 6];
                            case 4:
                                e_1 = _b.sent();
                                reject(e_1);
                                return [3 /*break*/, 6];
                            case 5:
                                a.waiting = false;
                                ref.close();
                                return [7 /*endfinally*/];
                            case 6: return [2 /*return*/];
                        }
                    });
                });
            });
            _this.actions = providedActions;
        });
        makeAutoObservable(this);
    }
    Object.defineProperty(Dialog.prototype, "_closeFromUiStore", {
        get: function () {
            return this.controller.dismiss;
        },
        enumerable: false,
        configurable: true
    });
    Dialog.prototype.close = function () {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.config.onBeforeClose) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.config.onBeforeClose()];
                    case 1:
                        result = _a.sent();
                        if (!result) {
                            resolve(false);
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        this.status = 'closing';
                        return [4 /*yield*/, tick(380)];
                    case 3:
                        _a.sent();
                        runInAction(function () {
                            _this.status = 'closed';
                        });
                        resolve();
                        this.controller.dismiss(this);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return Dialog;
}());
export default Dialog;
